import type { ReactNode } from "react"
import { cn } from "../utils/cn"

type Props = {
  children: ReactNode
  tone?: "green" | "slate" | "amber"
}

export function Badge({ children, tone = "slate" }: Props) {
  const tones = {
    green: "bg-emerald-50 text-emerald-700 border-emerald-100",
    slate: "bg-slate-100 text-slate-700 border-slate-200",
    amber: "bg-amber-50 text-amber-700 border-amber-100",
  }

  return <span className={cn("inline-flex items-center rounded-full border px-3 py-1 text-xs font-medium", tones[tone])}>{children}</span>
}
